

















































































































































































import productApi from "@/api/productApi";
import CustomerUser from "@/model/customerUser";
import Product, { SaleBoom } from "@/model/product";
import {Component, Prop, Vue} from "vue-property-decorator";
import { namespace } from "vuex-class";
import qNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import {ADMIN_TYPE, MAX_PRICE} from "@/common/constant";
import {CartItemList} from "@/model/cart";

const authStore = namespace("Auth");
const cartStore = namespace("Cart");
@Component({
  name: "productPopup",
  components: {
    QErrors,
  },
})
export default class productPopup extends Vue {
  public isShow = false;
  public product: Product = new Product();
  public saleBoms: SaleBoom[] = [];
  public errors: any = {};
  public classError = "AttentionBalloon";

  @Prop({
    type: CartItemList,
    default() {
      return new CartItemList();
    },
  })
  itemsList;

  @authStore.Getter
  public getCustomerUser!: CustomerUser;


  @authStore.Getter
  getUserType!: string;

  @cartStore.Getter
  isLimitAddCart!: boolean;

  get isCustomer() {
    return this.getUserType != ADMIN_TYPE;
  }

  show(product: any) {
    this.isShow = true;
    this.loadDetail(product.item_code);
  }

  async loadDetail(itemCode) {
    const loader = Vue.$loading.show({});
    const requests: any = [
      productApi.getDetail(itemCode),
      productApi.getSaleBom(itemCode),
    ];
    const result: any = await Promise.all(requests);
    loader.hide();
    result[0] && (this.product = result[0]);
    result[1] && (this.saleBoms = result[1]);

  }

  public async addToOrder() {
    if (!this.canProcess()) {
      return;
    }
    let items: any[] = this.saleBoms.filter((item) => item.cart_quanlity > 0);
    if (this.product.cart_quanlity > 0) {
      items.unshift(this.product);
    }

    try {
      this.$emit('addItems' , items)
      this.isShow = false;
    } catch (error) {
      console.log("error", error);
      qNotify.error({
        text: error,
      });
    }
  }

  public canProcess() {
    let flag = 0;
    for (let key of Object.keys(this.errors)) {
      if (this.errors[key].length > 0) {
        flag++;
      }
    }

    if (flag > 0) {
      qNotify.error({
        text: this.$t("cart_page.validate.max_price"),
      });
    }

    return flag === 0;
  }

  public handleChangeBoomQuantity(item: any, index: number, key) {
    console.log(this.itemsList.list)
    console.log('item', item);
    console.log('item.totall', item.total);
    console.log(this.itemsList.list
      .filter(function(cart) {
        console.log(cart)
        console.log(cart.item)
      }));
    const total = this.itemsList.list
      .filter(
        (cart) =>
          cart.item.set_item_code === item.set_item_code &&
          cart.item.item_code === item.item_code
      )
      /* eslint-disable unicorn/no-array-reduce */
      .reduce((memo, cart) => {
        return cart.item.cart_quanlity * cart.item.price + memo;
      }, 0) + item.total;
    // group prod to sum
    if (total > MAX_PRICE) {
      this.errors = {
        ...this.errors,
        ...{
          [`cart.${index}.${key}`]: [this.$t("cart_page.validate.max_price")],
        },
      };
    } else {
      this.errors = {
        ...this.errors,
        ...{ [`cart.${index}.${key}`]: [] },
      };
    }
  }
}
